import * as tslib_1 from "tslib";
import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import axios from "axios";
import AuthServiceFactory from "@/services/authentication/AuthServiceFactory";
let SearchResultsView = class SearchResultsView extends Vue {
    constructor() {
        super();
        this.authService = AuthServiceFactory.GetAuthService();
        this.user = null;
        this.searchTerm = "";
        this.searchResults = { hits: { total: 0 } };
        this.resultHeaders = [
            {
                text: "Title",
                align: "start",
                sortable: false,
                value: "title"
            },
            {
                text: "File Size (bytes)",
                align: "start",
                sortable: false,
                value: "_source.fileSizeBytes"
            }
        ];
        this.fileIcons = {
            html: "mdi-language-html5",
            js: "mdi-nodejs",
            json: "mdi-json",
            md: "mdi-markdown",
            pdf: "fas fa-file-pdf",
            png: "mdi-file-image",
            txt: "mdi-file-document-outline",
            xls: "fas fa-file-excel",
            xlsx: "fas fa-file-excel",
            "application/msword": "fas fa-file-word",
            doc: "fas fa-file-word"
        };
    }
    roundMe(value, places) {
        return value.toFixed(places);
    }
    getReadableFileSizeString(fileSizeInBytes) {
        var i = -1;
        var byteUnits = [" KB", " MB", " GB", " TB", "PB", "EB", "ZB", "YB"];
        do {
            fileSizeInBytes = fileSizeInBytes / 1024;
            i++;
        } while (fileSizeInBytes > 1024);
        return Math.max(fileSizeInBytes, 0.1).toFixed(1) + byteUnits[i];
    }
    async mounted() {
        this.searchTerm = this.$route.params.searchTerm;
        if ((await this.authService.isLoggedIn()) === true) {
            this.user = await this.authService.getUser();
        }
        await this.getSearchResults();
    }
    async onRouteChanged(value, oldValue) {
        this.searchTerm = this.$route.params.searchTerm;
        if ((await this.authService.isLoggedIn()) === true) {
            this.user = await this.authService.getUser();
        }
        await this.getSearchResults();
    }
    async getSearchResults() {
        let url = "https://search-bis-cms-pukopde3oqow3lc27uvdjbmwoe.us-east-1.es.amazonaws.com/cms/_search?q=" +
            this.searchTerm; // Put elasticsearch URL here
        let response = { data: {} };
        try {
            /* If we needed headers on our request
            let authHeader = {
              headers: {
                "Authorization": this.user.access_token,
                "Content-Type": "application/json"
              }
            };
            */
            // @ts-ignore
            //response = await axios.post(url, postbody, authHeader);
            //response = await axios.get(url, authHeader);
            response = await axios.get(url);
            if (response.data.hits.total.value > 0) {
                this.searchResults = response.data;
            }
            else {
                this.searchResults = { hits: { total: 0 } };
            }
            /* values will be saved at response.data */
            console.log("Response: " + JSON.stringify(response.data));
        }
        catch (error) {
            console.log("error", "Failed to call " + url + " ", error.message);
        }
    }
};
tslib_1.__decorate([
    Watch("$route", { immediate: true, deep: true })
], SearchResultsView.prototype, "onRouteChanged", null);
SearchResultsView = tslib_1.__decorate([
    Component({
        name: "SearchResultsView",
        components: {}
    })
], SearchResultsView);
export default SearchResultsView;
